<label
    class="sponsor-entry"
    [for]="'sponsor-checkbox-' + sponsor().id"
>
    <div class="checkbox-wrapper">
        <cwo-custom-checkbox
            #inputElement
            [id]="'sponsor-checkbox-' + sponsor().id"
            [ariaLabel]="sponsor().name"
            [ngModel]="selected"
            (ngModelChange)="onSponsorToggle($event)"
            [useStopPropagation]="true"
            [borderHighlight]="true"
        ></cwo-custom-checkbox>
    </div>
    <span class="sponsor-name" aria-hidden="true">{{ sponsor().name }}</span>
</label>